import { render, staticRenderFns } from "./InvoiceAmountDetail.vue?vue&type=template&id=aba69762&scoped=true"
import script from "./InvoiceAmountDetail.vue?vue&type=script&lang=ts"
export * from "./InvoiceAmountDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba69762",
  null
  
)

export default component.exports